<script lang="ts">
    import socialArrow from 'src/components/main/#assets/social-arrow.svg'
    import telegram from 'src/components/main/#common/visit-community/telegram.svg'
    import twitter from 'src/components/main/#common/visit-community/twitter.svg'
    import discord from 'src/components/main/#common/visit-community/discord.svg'
    import medium from 'src/components/main/#common/visit-community/medium.svg'
    import instagram from 'src/components/main/#common/visit-community/instagram.svg'
    import email from 'src/components/main/#common/visit-community/email.svg'
</script>
<section class="visit-community">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <div class="visit-community-content">
                    <div class="section-title">Visit the Realis Community</div>
                    <div class="description">To receive the latest news, participate in contests and exchange information with other fans of our games.</div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="social-links">
                    <div class="social-link">
                        <div class="icon">
                            <img src="{telegram}" alt="">
                        </div>
                        <div class="text">
                            <a href="https://t.me/RealisANN" target="_blank" class="name notranslate">Telegram<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Ask general questions and chat with the worldwide community on Telegram.</div>
                        </div>
                    </div>
                    <div class="social-link">
                        <div class="icon">
                            <img src="{twitter}" alt="">
                        </div>
                        <div class="text">
                            <a href="https://twitter.com/realisnetwork" target="_blank" class="name notranslate">Twitter<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Follow @realisnetwork to get the latest news and updates from across the ecosystem.</div>
                        </div>
                    </div>
                    <!--
                    <div class="social-link">
                        <div class="icon">
                            <img src="{discord}" alt="">
                        </div>
                        <div class="text">
                            <a href="https://discord.gg/realis" target="_blank" class="name notranslate">Discord<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Have technical questions about Realis Network tools? Ask a developer on the Community Discord. </div>
                        </div>
                    </div>
                    <div class="social-link">
                        <div class="icon">
                            <img src="{medium}" alt="">
                        </div>
                        <div class="text">
                            <a href="https://realisnetwork.medium.com/" target="_blank" class="name notranslate">Medium<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Stay tuned for our blog and game development news.</div>
                        </div>
                    </div>
                    <div class="social-link">
                        <div class="icon">
                            <img src="{instagram}" alt="">
                        </div>
                        <div class="text">
                            <a href="https://www.instagram.com/realis.network/" target="_blank" class="name notranslate">Instagram<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Learn more about the Realis team, the development process, and participate in cool unique contests.</div>
                        </div>
                    </div>
                    -->
                    <div class="social-link">
                        <div class="icon">
                            <img src="{email}" alt="">
                        </div>
                        <div class="text">
                            <a href="mailto:support@realis.network" class="name">Email<img src="{socialArrow}" alt=""></a>
                            <div class="caption">Our mail for personal questions about cooperation and others.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .visit-community {
        margin: 118px 0 150px;
        position: relative;
        z-index: 2;
    }

    .visit-community-content {
        position: relative;
        height: 100%;
    }

    .section-title {
        font-family: 'Anton', sans-serif;
        font-size: 43px;
        font-weight: 400;
        color: white;
        margin: -10px 0 30px;
        line-height: normal;
    }

    .description {
        font-size: 18px;
        color: #CED5E3;
        font-weight: 400;
        line-height: normal;
        max-width: 550px;
    }

    .social-link {
        display: flex;
        margin-bottom: 50px;
        color: white;
        transition: .25s;
        cursor: default;
    }

    .social-link:hover {
        transform: translateY(-0.125rem);
    }

    .social-link:last-child {
        margin-bottom: 10px;
    }

    .icon {
        margin-right: 23px;
        transition: .25s;
    }

    .name {
        margin: 5px 0 15px;
        font-family: 'Anton', sans-serif;
        font-size: 20px;
        line-height: 20px;
        color: white;
        text-decoration: none;
        display: table;
        text-transform: uppercase;
        transition: .25s;
        cursor: pointer;
    }

    .social-link:hover .name {
        color: #FF5D1C;
    }

    .social-link:hover .icon {
        opacity: 0.8;
    }

    .name img {
        margin-left: 10px;
        transition: .25s;
    }

    .caption {
        font-size: 14px;
        line-height: 21px;
        color: #BDBDBD;
        transition: .25s;
    }

    .name:hover img {
        transform: rotate(45deg);
    }

    .social-link:hover .caption {
        color: rgba(255, 255, 255, 0.8);
    }

    .social-link:hover .name img {
        opacity: 0.8;
    }

    @media (max-width: 991px) {
        .description {
            font-size: 16px;
        }
    }

    @media (max-width: 767px) {
        .visit-community {
            margin: 60px 0 40px;
        }

        .visit-community-content {
            padding-bottom: 50px;
        }

        .visit-community-content:before {
            display: none;
        }

        .section-title {
            font-size: 40px;
            line-height: 50px;
            margin-bottom: 20px;
            text-align: center;
        }

        .description {
            text-align: center;
            margin: 0 auto;
        }

        .visit-community .btn {
            font-size: 16px;
            padding: 16px 34px;
        }

        .caption {
            font-size: 12px;
            line-height: 18px;
        }

        .icon {
            margin-right: 10px;
            width: 30px;
            min-width: 30px;
        }

        .icon img {
            max-width: 100%;
        }

        .social-link {
            margin-bottom: 30px;
        }

        .social-links {
            position: relative;
            padding-bottom: 40px;
        }

        .social-link:last-child {
            margin-bottom: 0;
        }
    }
</style>
